/* Luminate theme JS — Phase 0 scaffold.
   Phase 1 adds: AJAX cart drawer, predictive search, mobile nav drawer, variant picker. */

// Scroll-reveal (replaces framer-motion whileInView for simple cases)
(function () {
  var els = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window) || els.length === 0) {
    els.forEach(function (el) { el.classList.add('is-revealed'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { io.observe(el); });
})();

// Mobile nav drawer: open/close, accordion groups, Escape, focus to the close button
(function () {
  var nav = document.getElementById('MobileNav');
  if (!nav) return;
  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    nav.classList.add('is-open');
    nav.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('lum-drawer-open'); // hides the chat bubble while open
    var close = nav.querySelector('[data-mobile-close].lum-mnav__close');
    if (close) setTimeout(function () { close.focus(); }, 320);
  }
  function close() {
    nav.classList.remove('is-open');
    nav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.body.classList.remove('lum-drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mobile-open]')) { open(); return; }
    if (e.target.closest('[data-mobile-close]')) { close(); return; }
    var toggle = e.target.closest('[data-mnav-toggle]');
    if (toggle && nav.contains(toggle)) {
      var group = toggle.closest('[data-mnav-group]');
      var sub = group && group.querySelector(':scope > .lum-mnav__sub');
      if (!sub) return;
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      // one top-level group open at a time keeps the list short
      if (!expanded && !toggle.classList.contains('lum-mnav__toggle--sub')) {
        nav.querySelectorAll('.lum-mnav__list > [data-mnav-group] > [data-mnav-toggle][aria-expanded="true"]').forEach(function (t) {
          t.setAttribute('aria-expanded', 'false');
          var s = t.closest('[data-mnav-group]').querySelector(':scope > .lum-mnav__sub');
          if (s) s.hidden = true;
        });
      }
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      sub.hidden = expanded;
      if (!expanded) toggle.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && nav.classList.contains('is-open')) close();
  });
})();

// Desktop navigation: connected trigger bridge and brief directional exit grace.
(function () {
  var root = document.querySelector('.lum-header__desktop');
  if (!root) return;
  var groups = Array.from(root.querySelectorAll('[data-mega]'));
  var desktop = window.matchMedia('(min-width:1024px)'), current = null, timer, lastY = 0, restoringFocus = false;
  root.classList.add('lum-mega-managed');
  function close() {
    clearTimeout(timer);
    groups.forEach(function (group) {
      group.classList.remove('is-mega-open');
      group.querySelector(':scope > a').setAttribute('aria-expanded', 'false');
      group.querySelector('.mega-panel').inert = true;
    });
    current = null;
  }
  function bridge(group) {
    var trigger = group.querySelector(':scope > a').getBoundingClientRect();
    var panel = group.querySelector('.mega-panel').getBoundingClientRect();
    var node = group.querySelector('.lum-mega-bridge');
    var base = node.offsetParent ? node.offsetParent.getBoundingClientRect() : {left:0, top:0};
    node.style.left = (trigger.left - base.left) + 'px'; node.style.top = (trigger.bottom - base.top) + 'px';
    node.style.width = trigger.width + 'px'; node.style.height = Math.max(0, panel.top - trigger.bottom + 5) + 'px';
  }
  function open(group) {
    if (!desktop.matches || document.body.classList.contains('lum-cart-open') || document.querySelector('.is-search-open')) return;
    if (Array.from(document.querySelectorAll('[data-predictive-panel]')).some(function (p) { return !p.hidden && p.getClientRects().length; })) return;
    clearTimeout(timer);
    if (current !== group) close();
    document.dispatchEvent(new CustomEvent('luminate:navigation-open'));
    current = group; group.classList.add('is-mega-open');
    group.querySelector(':scope > a').setAttribute('aria-expanded', 'true');
    group.querySelector('.mega-panel').inert = false; bridge(group);
  }
  function later() { clearTimeout(timer); timer = setTimeout(function () { if (!current || !current.contains(document.activeElement)) close(); }, 240); }
  groups.forEach(function (group) {
    var trigger = group.querySelector(':scope > a'), panel = group.querySelector('.mega-panel');
    panel.id = panel.id || 'MegaPanel-' + group.dataset.mega;
    trigger.setAttribute('aria-controls', panel.id); trigger.setAttribute('aria-expanded', 'false'); panel.inert = true;
    var node = document.createElement('span'); node.className = 'lum-mega-bridge'; node.setAttribute('aria-hidden', 'true'); group.appendChild(node);
    group.addEventListener('pointerover', function (e) {
      if (e.pointerType === 'touch') return;
      if (!group.contains(e.relatedTarget)) open(group);
      else if (current === group) clearTimeout(timer);
    });
    group.addEventListener('pointerout', function (e) {
      if (e.pointerType === 'touch' || group.contains(e.relatedTarget)) return;
      lastY = e.clientY; if (current === group) later();
    });
    group.addEventListener('focusin', function () { if (!restoringFocus) open(group); });
    group.addEventListener('focusout', function () { setTimeout(function () { if (current === group && !group.contains(document.activeElement) && !group.matches(':hover')) close(); }, 0); });
    trigger.addEventListener('keydown', function (e) { if (e.key === 'ArrowDown') { e.preventDefault(); open(group); var first = panel.querySelector('a,button'); if (first) first.focus(); } });
    var touchDisclosure = false;
    trigger.addEventListener('pointerdown', function (e) { touchDisclosure = e.pointerType === 'touch' && current !== group; });
    trigger.addEventListener('click', function (e) {
      // On touch-capable desktop layouts, first tap discloses; the next follows
      // the original destination. Mouse and keyboard retain normal link behavior.
      if (desktop.matches && touchDisclosure) { e.preventDefault(); touchDisclosure = false; open(group); }
    });
  });
  document.addEventListener('pointermove', function (e) {
    if (!current || e.pointerType === 'touch' || current.contains(e.target)) return;
    var panel = current.querySelector('.mega-panel').getBoundingClientRect();
    var trigger = current.querySelector(':scope > a').getBoundingClientRect();
    // Renew only while moving down through the real trigger-to-panel corridor.
    // There is no hit target over neighboring navigation or search controls.
    if (e.clientY >= lastY && e.clientY >= trigger.bottom - 2 && e.clientY <= panel.top + 5 && e.clientX >= panel.left && e.clientX <= panel.right) later();
    lastY = e.clientY;
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !current) return;
    var trigger = current.querySelector(':scope > a'), hadFocus = current.contains(document.activeElement);
    close(); if (hadFocus) { e.preventDefault(); restoringFocus = true; trigger.focus({preventScroll:true}); restoringFocus = false; }
  });
  document.addEventListener('pointerdown', function (e) { if (current && !current.contains(e.target)) close(); });
  document.addEventListener('pointerover', function (e) { if (e.target.closest('[data-cart-open]')) close(); });
  document.addEventListener('focusin', function (e) { if (e.target.closest('[data-predictive-wrap]')) close(); });
  document.addEventListener('luminate:search-open', close); document.addEventListener('luminate:cart-open', close);
  desktop.addEventListener('change', close);
  window.addEventListener('resize', function () { if (current) bridge(current); });
  window.addEventListener('scroll', function () { if (current) bridge(current); }, {passive:true});
  function switchTab(e) {
    if (e.type === 'pointerover' && e.pointerType === 'touch') return;
    var tab = e.target.closest('[data-menu-tab]'); if (!tab) return;
    var panelRoot = tab.closest('.mega-panel'); if (!panelRoot) return;
    panelRoot.querySelectorAll('[data-menu-tab]').forEach(function (t) { var active = t === tab; t.classList.toggle('bg-primary', active); t.classList.toggle('text-primary-foreground', active); t.classList.toggle('hover:bg-muted', !active); });
    panelRoot.querySelectorAll('[data-menu-panel]').forEach(function (p) { p.hidden = p.dataset.menuPanel !== tab.dataset.menuTab; });
  }
  document.addEventListener('pointerover', switchTab); document.addEventListener('focusin', switchTab);
})();

// Keep header cart count in sync after AJAX cart changes (Phase 1 wires the drawer)
window.LuminateCart = {
  countRequest: 0,
  refreshCount: function () {
    var request = ++this.countRequest;
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { if (!r.ok) throw new Error('Cart count unavailable'); return r.json(); })
      .then(function (cart) {
        if (request !== window.LuminateCart.countRequest) return;
        var depositIds = [43126847537217, 43126849273921, 43126851305537, 43126853107777, 43126854615105];
        var count = cart.items.reduce(function (total, item) {
          var handle = item.handle || '';
          var title = (item.product_title || item.title || '').toLowerCase();
          var deposit = depositIds.indexOf(Number(item.variant_id || item.id)) !== -1 || handle.indexOf('bottle-deposit') !== -1 || title.indexOf('bottle deposit') !== -1;
          return total + (deposit ? 0 : Number(item.quantity || 0));
        }, 0);
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = String(count);
          el.classList.toggle('hidden', count === 0);
          el.hidden = count === 0;
          el.setAttribute('aria-hidden', 'true');
        });
        document.querySelectorAll('[data-cart-open]').forEach(function (el) {
          el.setAttribute('aria-label', 'Cart, ' + count + ' item' + (count === 1 ? '' : 's'));
        });
      }).catch(function () {});
  }
};

// Get Directions dialog (transposes DirectionsDialog.tsx).
// theme.js loads mid-body, before the dialog snippet at the end of <body>,
// so initialization waits for the full DOM.
function initDirectionsDialog() {
  var dlg = document.querySelector('[data-directions-dialog]');
  if (!dlg) return;
  var input = dlg.querySelector('#DirectionsOrigin');
  var go = dlg.querySelector('[data-directions-go]');
  var sugBox = dlg.querySelector('[data-directions-suggestions]');
  var mapsKey = dlg.getAttribute('data-maps-key');
  var DEFAULT_STORE = dlg.getAttribute('data-default-destination') || '486 Starboard Dr, Halifax B3M 0N6';
  // set per-trigger: each Get directions button can name its own store
  var destination = DEFAULT_STORE;
  var placesService = null;
  var placesLoading = false;
  var debounceTimer = null;

  // Places autocomplete (as on the live site) — loads Google Maps JS on first open
  function loadPlaces() {
    if (!mapsKey || placesService || placesLoading) return;
    if (window.google && window.google.maps && window.google.maps.places) {
      placesService = new window.google.maps.places.AutocompleteService();
      return;
    }
    placesLoading = true;
    window.__lumPlacesReady = function () {
      try { placesService = new window.google.maps.places.AutocompleteService(); } catch (e) { /* plain input still works */ }
    };
    var tag = document.createElement('script');
    tag.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(mapsKey) + '&libraries=places&callback=__lumPlacesReady';
    tag.async = true;
    tag.onerror = function () { placesLoading = false; };
    document.head.appendChild(tag);
  }
  function hideSuggestions() {
    if (sugBox) { sugBox.hidden = true; sugBox.innerHTML = ''; }
  }
  function showSuggestions(preds) {
    if (!sugBox || !preds || !preds.length) { hideSuggestions(); return; }
    sugBox.innerHTML = '';
    preds.forEach(function (pr) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'w-full text-left px-4 py-3 hover:bg-muted transition-colors border-b border-border last:border-b-0';
      var main = document.createElement('div');
      main.className = 'font-medium';
      main.textContent = (pr.structured_formatting && pr.structured_formatting.main_text) || pr.description;
      var sec = document.createElement('div');
      sec.className = 'text-sm text-muted-foreground';
      sec.textContent = (pr.structured_formatting && pr.structured_formatting.secondary_text) || '';
      b.appendChild(main);
      b.appendChild(sec);
      b.addEventListener('click', function () {
        input.value = pr.description;
        go.disabled = false;
        hideSuggestions();
        input.focus();
      });
      sugBox.appendChild(b);
    });
    sugBox.hidden = false;
  }
  function fetchSuggestions() {
    var q = input.value.trim();
    if (!placesService || q.length < 3) { hideSuggestions(); return; }
    placesService.getPlacePredictions(
      { input: q, componentRestrictions: { country: 'ca' } },
      function (preds, status) { showSuggestions(status === 'OK' ? preds : null); }
    );
  }

  function open() {
    dlg.hidden = false;
    document.body.style.overflow = 'hidden';
    loadPlaces();
    setTimeout(function () { input.focus(); }, 50);
  }
  function close() {
    dlg.hidden = true;
    document.body.style.overflow = '';
    input.value = '';
    go.disabled = true;
    hideSuggestions();
  }
  function submit() {
    var origin = input.value.trim();
    if (!origin) return;
    window.open('https://www.google.com/maps/dir/?api=1&origin=' + encodeURIComponent(origin) +
      '&destination=' + encodeURIComponent(destination), '_blank');
    close();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-directions-open]');
    if (trigger) {
      e.preventDefault();
      destination = trigger.getAttribute('data-destination') || DEFAULT_STORE;
      var label = dlg.querySelector('[data-directions-destination]');
      if (label) label.textContent = destination;
      open();
      return;
    }
    if (dlg.hidden) return;
    if (e.target.closest('[data-directions-close]') || e.target.closest('[data-directions-close-overlay]')) close();
    else if (e.target.closest('[data-directions-go]')) submit();
  });
  input.addEventListener('input', function () {
    go.disabled = !input.value.trim();
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(fetchSuggestions, 500); // same 500ms debounce as the live site
  });
  input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); hideSuggestions(); submit(); } });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !dlg.hidden) close(); });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDirectionsDialog);
else initDirectionsDialog();

/* Header condensation — flips a flag at 80px so CSS can shrink the bar. */
(function () {
  var header = document.querySelector('[data-lum-header]');
  if (!header) return;
  var ticking = false;
  function apply() {
    header.setAttribute('data-scrolled', window.scrollY > 80 ? 'true' : 'false');
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(apply);
  }, { passive: true });
  apply();
})();

